module.exports = __webpack_public_path__ + "static/media/53127fbfa400f71fc1dd0c0b99894922.53127fbf.webp";